import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
// import { ExternalLink } from './ExternalLink';

const styles = (theme) => ({
  getPluto: {
    margin: '0 auto',
    width: '200px',
    display: 'block',
    textAlign: 'center',
    borderRadius: '20px',
    boxShadow: 'none',
    background: '#ffde2b',
  },
  submitWrapper: {
    margin: '0 auto',
    width: '200px',
  },
  getPlutoButton: {
    fontSize: 16,
    textTransform: 'none',
  },
  success__heroImg: {
    display: 'block',
    width: '100%',
  },
  success__subtext: {
    color: '#4f4f4f',
    margin: '0 auto 16px',
    fontFamily: 'Pluto Sans Semibold',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginBottom: '28px',
      maxWidth: '488px',
    },
  },
  success__tabContainer: {
    margin: '0 auto',
    padding: '4px 20px 40px',
    [theme.breakpoints.up('md')]: {
      padding: '25px 45px 0px',
    },
  },
  success__title: {
    fontFamily: 'Pluto Sans Bold',
    color: '#000',
    fontSize: '2em',
    margin: '12px 0',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: '3em',
      margin: '38px 0 14px',
    },
  },
});

const LoginSuccessTabComponent = ({ classes, userName, t, ...props }) => (
  <div className={classes.success__tabContainer}>
    <img className={classes.success__heroImg} src="/assets/images/PlutoTV_Devices.png" />
    <h1 className={classes.success__title}>
      {userName !== 'Citizen' ? `${t('welcome')} ${userName}` : `${t('welcome_to_pluto_tv')}`}
    </h1>
    <h4 className={classes.success__subtext}>
      {t(
        'watch_over_250_channels',
        "Watch over 250 channels of movies, news, sports and more as well as 1000's of on-demand movies & TV shows.",
      )}
    </h4>

    <Button
      className={classes.getPluto}
      classes={{ label: classes.getPlutoButton }}
      color="primary"
      onClick={props.onClose}
      variant="contained"
    >
      {t('watch_live_tv')}
    </Button>
  </div>
);
LoginSuccessTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  userName: PropTypes.string.isRequired,
};

export const LoginSuccessTab = withStyles(styles)(withNamespaces()(LoginSuccessTabComponent));
